export const AUTH_PROXY_URL = process.env.REACT_APP_AUTH_PROXY_URL;
